<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordovio/svgVio30bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 55px; top: 55px;">
      <p>Busca el título del poema y señalalo.</p>
    </span>

    <label
      class="toggleButtonContainer pageElement"
      id="toggle01"
      style="width: 360px"
      >EL BICHITO PERDIDO.
      <input type="radio" name="violin" 
      ref="1-1" 
      v-on:change="saveOption('radios', 1, 1)" 
      :onload="loadOption('radios', 1, 1)"/>
      <span class="toggleButton"></span>
    </label>
    <label
      class="toggleButtonContainer pageElement"
      id="toggle02"
      style="width: 360px"
      >EL VIOLÍN PERDIDO.
      <input type="radio" name="violin" 
      ref="1-2" 
      v-on:change="saveOption('radios', 1, 2)" 
      :onload="loadOption('radios', 1, 2)"/>
      <span class="toggleButton"></span>
    </label>
    <label
      class="toggleButtonContainer pageElement"
      id="toggle03"
      style="width: 360px"
      >EL VIOLÍN PERFECTO.
      <input type="radio" name="violin" 
      ref="1-3" 
      v-on:change="saveOption('radios', 1, 3)" 
      :onload="loadOption('radios', 1, 3)"/>
      <span class="toggleButton"></span>
    </label>
    <label
      class="toggleButtonContainer pageElement"
      id="toggle04"
      style="width: 360px"
      >EL VIOLÍN BUSCADO.
      <input type="radio" name="violin" 
      ref="1-4" 
      v-on:change="saveOption('radios', 1, 4)" 
      :onload="loadOption('radios', 1, 4)"/>
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 54px;
  top: 75px;
}

#toggle01{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 188.86px;

z-index: 3;
}
#toggle02{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 262.95px;
z-index: 3;

}
#toggle03{/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 336.09px;
z-index: 3;
}
#toggle04{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 410.18px;
z-index: 3;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>